export default {
  // 新增费用记录
  insertPaExpenseRecord: '/ygsjzs/paExpenseRecord/insertPaExpenseRecord',
  // 修改费用记录
  updatePaExpenseRecord: '/ygsjzs/paExpenseRecord/updatePaExpenseRecord',
  // 物理删除费用记录
  deleteDataPaExpenseRecord: '/ygsjzs/paExpenseRecord/deleteDataPaExpenseRecord',
  // 查询费用记录详情
  selectPaExpenseRecordByExpenseId: '/ygsjzs/paExpenseRecord/selectPaExpenseRecordByExpenseId',
  // 分页查询费用记录列表
  selectPaExpenseRecordByPage: '/ygsjzs/paExpenseRecord/selectPaExpenseRecordByPage',
  // 统计总费用
  selectPaExpenseCount: '/ygsjzs/paExpenseRecord/selectPaExpenseCount',
  // 导出
  exportPaExpenseCount: '/ygsjzs/paExpenseRecord/exportPaExpenseCount'
}
